import { Button } from '@hai/ui-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAdaptiveFetch } from 'src/js/hook/use-adaptive-fetch';
import { useStores } from 'src/js/hook/use-stores';
import { StatisticTable } from 'src/js/pages/statistic/statistic-table';

import { VideoEncoderViewModel } from './video-encoder-models';
import { mapVidEncToStatistics } from './video-encoder-statistics-content';
import { fetchVideoEncoderStatistics, resetVideoEncoderStatistics } from './video-encoder-store';

interface Props {
  model: VideoEncoderViewModel;
}

export const VideoEncoderStatistics: React.FunctionComponent<Props> = ({ model }) => {
  const { t } = useTranslation();
  const { sessionStore } = useStores();

  const [data, setData] = useState(model);
  useAdaptiveFetch(() => fetchVideoEncoderStatistics(model, t, setData), 5000);

  const handleResetStatistics = () => {
    resetVideoEncoderStatistics(model, t, setData);
  };

  return (
    <>
      <StatisticTable sections={mapVidEncToStatistics(data, t)} minimumGroup={3} />
      {!sessionStore.isUser() && (
        <div className="d-flex hai-mt-5">
          <Button className="ml-auto" variant="secondary" onClick={handleResetStatistics}>
            {t('statistics.button.resetStats')}
          </Button>
        </div>
      )}
    </>
  );
};
